module.exports = __webpack_public_path__ + "img/certificate1-03.f88da970.png";